
import httpClient from './httpClient';
const prefix = 'clientContact'

export default {
  async getClientContactByCompany() {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getClientContactByCompany`)

    return data
  },

  async getClientContactByCompany() {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getClientContactByCompany`)

    return data
  },

  async getClientContactByCompanyAndId(id) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getClientContactByCompanyAndId/${id}`)

    return data
  },

  async updatePhoneNo(id, phone_no) {
    const { data } = await httpClient({ requiresAuth: true }).post(`${prefix}/updatePhoneNo`, 
      { 
        id: id,
        phone_no: phone_no
      })

    return data
  },
}